function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#ff9800;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M298.367,235.887l26.964-26.899l-27.503-27.481l-26.899,26.963 c-11.281-7.679-24.159-13.007-38.008-15.704v-38.116h-38.784v38.137c-13.892,2.675-26.705,7.981-37.943,15.682l-26.963-26.963 l-27.438,27.481l26.877,26.899c-7.571,11.282-12.899,24.073-15.596,38.008h-38.18v38.763h38.18 c2.696,13.848,8.003,26.661,15.596,37.943l-26.877,26.963l27.416,27.438l26.963-26.92c11.238,7.636,24.073,12.964,37.965,15.66 v38.159h38.806v-38.159c13.848-2.653,26.683-7.96,38.008-15.617l26.899,26.877l27.503-27.438l-26.963-26.963 c7.636-11.238,12.986-24.095,15.574-37.943h38.223v-38.763h-38.245C311.331,259.96,306.025,247.169,298.367,235.887z  M213.508,335.652c-23.361,0-42.322-19.047-42.322-42.451c0-23.34,18.961-42.343,42.322-42.343 c23.426,0,42.408,19.004,42.408,42.343C255.937,316.605,236.955,335.652,213.508,335.652z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M336.073,105.362c-34.017-21.765-74.247-34.6-117.582-34.6C97.823,70.763,0,168.565,0,289.232 c0,50.432,17.257,96.659,45.903,133.674l27.438-27.416c-21.83-29.789-35.117-66.222-35.117-106.085 c0-99.549,80.696-180.202,180.245-180.202c33.111,0,63.655,9.556,90.338,25.303l-21.053,22.434l85.571,7.765l-9.189-89.346 L336.073,105.362z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "502.664,293.826 449.061,240.245 449.061,270.25 378.503,270.25 378.503,317.403  449.061,317.403 449.061,347.473  "
}));

const SvgDevelopmentAndProgress = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 502.664 502.664",
    style: {
      enableBackground: "new 0 0 502.664 502.664"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDevelopmentAndProgress, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/development-and-progress.e8b1adc8.svg";
export { ForwardRef as ReactComponent };